import {
    GET_EQUIPMENT_GROUP_LIST_REQUEST, GET_EQUIPMENT_GROUP_LIST, APPLY_EG_FILTERS, UPDATE_EG_INFO, CREATE_EG,
    EG_SELECTION, HANDLE_EG_DRAG_DROP, GET_OPTION_LIST_REQUEST, GET_OPTION_LIST, SET_FILTER_LIST,
    RESET_EG, EG_SAVE_REQUEST, EG_SAVE_SUCCESS, EG_SAVE_FAILURE, CLEAR_EG_KANBAN, VALIDATE_EG
} from "../constants/action-types";
import { compareTwo } from '../components/EquipmentGroupKanban/utils';
import { EG_OPTION_TYPES, EQUIPMENT_PERSON, EQUIPMENT_TRUCK, EQUIPMENT_SELF_PROPELLED } from "../constants";
import { isToday, isUUID } from "../helpers/common";

const getColumns = (count, selected) =>
    Array.from({ length: count }, (v, k) => k).map(k => ({
        columnId: `column${k + 1}`,
        egId: (selected && k < selected.length) ? selected[k] : null
    }));

const initialState = {
    isRequestingEg: false,
    isRequestingSave: false,
    isValidateEg: false,
    refresh: 0,
    filters: {
        farmId: null
    },
    egListById: {},
    egList: [],
    allEgList: [],
    newEgList: [],
    columns: getColumns(8),
    kanban: {
        "vehicle": {
            title: "Vehicle",
            addTitle: "Add vehicle",
            list: []
        },
        "implement": {
            title: "Implement",
            addTitle: "Add implement",
            list: []
        },
        "device": {
            title: "Device",
            addTitle: "Add device",
            list: []
        },
        "operator": {
            title: "Operator",
            addTitle: "Add operator",
            list: []
        }
    },
    optionList: {
        vehicle: {
            isRequesting: false,
            list: [],
            listById: {},
            filteredList: []
        },
        implement: {
            isRequesting: false,
            list: [],
            listById: {},
            filteredList: []
        },
        device: {
            isRequesting: false,
            list: [],
            listById: {},
            filteredList: []
        },
        operator: {
            isRequesting: false,
            list: [],
            listById: {},
            filteredList: []
        }
    }
};

export default (state = initialState, action) => {
    switch (action.type) {
        case APPLY_EG_FILTERS: {
            const filters = action.payload;
            return { ...state, filters: { ...state.filters, ...filters } };
        }
        case GET_EQUIPMENT_GROUP_LIST_REQUEST: {
            return {
                ...state, isRequestingEg: true, egListById: {}, egList: []
            };
        }
        case GET_EQUIPMENT_GROUP_LIST: {
            const allEgList = action.payload ? action.payload : initialState.allEgList;
            const filterEgList = allEgList.filter(e => (isToday(action.range) ? e.alive : true));
            const egList = filterEgList.map(e => ({
                id: e.equipment_group_uuid,
                name: e.equipment_group_name,
                modeTypeId: e.equipment_group_mode_id,
                list: [e.vehicle.equipment_uuid, e.implement.equipment_uuid, e.phone_device.device_uuid, e.operator.operator_uuid],   //["vehicle","implement","device","operator"]
                startDate: e.vehicle.start_date
            }));

            const egListById = {};
            egList.forEach(e => egListById[e.id] = e);

            return {
                ...state, isRequestingEg: false, egListById, egList: filterEgList, allEgList
            };
        }
        case GET_OPTION_LIST_REQUEST: {
            return {
                ...state, optionList: {
                    ...state.optionList,
                    [action.optionType]: {
                        ...state.optionList[action.optionType],
                        isRequesting: true
                    }
                },
            };
        }
        case GET_OPTION_LIST: {
            const { optionType, payload } = action;
            const listById = {};

            const idType = {
                vehicle: "equipment_uuid",
                implement: "equipment_uuid",
                device: "device_uuid",
                operator: "person_uuid"
            };

            const nameType = {
                vehicle: "equipment_name",
                implement: "equipment_name",
                device: "device_name",
                operator: "name"
            };

            const subNameType = {
                vehicle: "primary_category_name",
                implement: "primary_category_name",
                operator:"last_login_date"
            };

            const subInfoType = {                
                operator:"last_logout_date"
            };

            const icons = {
                truck: "fa fa-truck",
                tractor: "icon icon-tractor",
                person: "fa fa-user",
                implement: "fa fa-link",
                device: "fa fa-mobile",
                operator: "fa fa-user"
            }

            const id = idType[optionType];
            const name = nameType[optionType];
            const subName = subNameType[optionType];
            const subInfo = subInfoType[optionType];

            payload.forEach(e => {
                let icon = "";
                if (optionType === "vehicle") {
                    if (e.equipment_type_id === EQUIPMENT_PERSON) icon = icons["person"];
                    else if (e.equipment_type_id === EQUIPMENT_TRUCK) icon = icons["truck"];
                    else icon = icons["tractor"];
                } else icon = icons[optionType];

                listById[e[id]] = {
                    id: e[id],
                    name: e[name],
                    ...subName && { subName: e[subName] },
                    ...subInfo && { subInfo: e[subInfo] },
                    icon
                };
            });

            return {
                ...state, optionList: {
                    ...state.optionList,
                    [optionType]: {
                        ...state.optionList[optionType],
                        isRequesting: false,
                        list: payload,
                        listById
                    }
                },
            };
        }
        case EG_SELECTION: {
            const columns = [...state.columns];
            const kanban = { ...state.kanban };
            const oldSelected = columns.filter(e => e.egId !== null).map(e => e.egId);
            const newSelected = action.payload;
            const { added, removed } = compareTwo(oldSelected, newSelected);

            for (const egId of removed) {
                const findIndex = columns.findIndex(e => e.egId === egId);
                if (findIndex < 0) continue;
                columns[findIndex].egId = null;
                if (kanban.hasOwnProperty(egId)) delete kanban[egId];
            }

            for (const egId of added) {
                const findIndex = columns.findIndex(e => e.egId === null);
                if (findIndex < 0) continue;
                columns[findIndex].egId = egId;
            }

            for (const id of newSelected) {
                if (!kanban.hasOwnProperty(id)) kanban[id] = state.egListById[id];
            }

            return { ...state, columns, kanban };
        }
        case SET_FILTER_LIST: {
            return {
                ...state,
                kanban: {
                    ...state.kanban,
                    [action.optionType]: {
                        ...state.kanban[action.optionType],
                        list: action.payload.newFilterData
                    }
                },
                optionList: {
                    ...state.optionList,
                    [action.optionType]: {
                        ...state.optionList[action.optionType],
                        filteredList: action.payload.oldFilterData
                    }
                }
            };
        }
        case HANDLE_EG_DRAG_DROP: {
            const { sourceIndex, destIndex, sourceId, destId, draggableId } = action.payload;

            // Move within the same list
            if (sourceId === destId) {
                if (EG_OPTION_TYPES.indexOf(sourceId) < 0) return;
                const newCards = Array.from(state.kanban[sourceId].list);
                const [removedCard] = newCards.splice(sourceIndex, 1);
                newCards.splice(destIndex, 0, removedCard);
                return {
                    ...state,
                    kanban: { ...state.kanban, [sourceId]: { ...state.kanban[sourceId], list: newCards } }
                };
            }

            // Move card from one list to another
            const sourceCards = Array.from(state.kanban[sourceId].list);
            const destinationCards = Array.from(state.kanban[destId].list);
            let optionCards = {};
            let removeCount;

            if (EG_OPTION_TYPES.indexOf(destId) >= 0) removeCount = 0;
            else removeCount = 1;

            const [removed] = destinationCards.splice(destIndex, removeCount, draggableId);

            if (EG_OPTION_TYPES.indexOf(destId) < 0 && EG_OPTION_TYPES.indexOf(sourceId) < 0) {
                if (removed) {
                    let list = Array.from(state.kanban[EG_OPTION_TYPES[sourceIndex]].list);
                    list = [removed, ...list];
                    optionCards = {
                        ...optionCards,
                        [EG_OPTION_TYPES[sourceIndex]]: {
                            ...state.kanban[EG_OPTION_TYPES[sourceIndex]],
                            list
                        }
                    }
                }
            }

            if (EG_OPTION_TYPES.indexOf(sourceId) >= 0)
                if (removed) sourceCards.splice(sourceIndex, 1, removed);
                else sourceCards.splice(sourceIndex, 1);
            else sourceCards.splice(sourceIndex, 1, "");

            //in order to remove implement type for truck and self propelled equipment group
            if (EG_OPTION_TYPES.indexOf(destId) < 0 && destIndex === 0) {
                const equipmentListById = {};
                state.optionList.vehicle.list.forEach(item => equipmentListById[item.equipment_uuid] = item);
                const removeImplementType = equipmentListById[draggableId]
                    ? [EQUIPMENT_TRUCK, EQUIPMENT_SELF_PROPELLED].indexOf(equipmentListById[draggableId].equipment_type_id) >= 0 : false;
                if (removeImplementType) {
                    const [removed] = destinationCards.splice(1, 1, "");
                    if (removed) {
                        let list = Array.from(state.kanban[EG_OPTION_TYPES[1]].list);
                        list = [removed, ...list];
                        optionCards = {
                            ...optionCards,
                            [EG_OPTION_TYPES[1]]: {
                                ...state.kanban[EG_OPTION_TYPES[1]],
                                list
                            }
                        }
                    }
                }
            }

            return {
                ...state, kanban: {
                    ...state.kanban,
                    [sourceId]: { ...state.kanban[sourceId], list: sourceCards, isChanged: true },
                    [destId]: { ...state.kanban[destId], list: destinationCards, isChanged: true },
                    ...optionCards
                }
            };
        }
        case UPDATE_EG_INFO: {
            const egId = action.egId;
            const isEditMode = state.egList.map(e => e.equipment_group_uuid).indexOf(egId) >= 0;
            let newEgList = state.newEgList;

            if (!isEditMode) {
                newEgList = newEgList.map(item => {
                    if (item.equipment_group_uuid === egId)
                        return ({
                            equipment_group_uuid: egId,
                            equipment_group_name: action.payload.name
                        })
                    else return item;
                })
            }

            //In order to handle mode type change
            const isModeChanged = action.payload.isModeChanged;

            delete action.payload.isModeChanged;
            let vehicleId = null;
            let implementId = null;
            let list = null;

            if (isModeChanged) {
                const egItems = state.kanban[egId].list;
                list = ["", "", egItems[2], egItems[3]];
                vehicleId = isUUID(egItems[0]) ? egItems[0] : null;
                implementId = isUUID(egItems[1]) ? egItems[1] : null;
            }

            return {
                ...state, kanban: {
                    ...state.kanban,
                    [egId]: {
                        ...state.kanban[egId],
                        isChanged: true,
                        ...action.payload,
                        ...list && { list }
                    },
                    ...vehicleId && { vehicle: { ...state.kanban.vehicle, list: [vehicleId, ...state.kanban.vehicle.list] } },
                    ...implementId && { implement: { ...state.kanban.implement, list: [implementId, ...state.kanban.implement.list] } }
                },
                newEgList
            };
        }
        case CREATE_EG: {
            const newEgId = action.egId;
            const egColumns = [...state.columns];

            const findIndex = egColumns.findIndex(e => e.egId === null);
            if (findIndex >= 0) egColumns[findIndex].egId = newEgId;

            return {
                ...state, columns: egColumns,
                kanban: {
                    ...state.kanban, [newEgId]: {
                        isChanged: true,
                        list: ["", "", "", ""],       //["vehicle","implement","device","operator"]
                        ...action.payload
                    }
                },
                newEgList: [...state.newEgList, {
                    equipment_group_uuid: newEgId,
                    equipment_group_name: action.payload.name
                }]
            };
        }
        case RESET_EG:
            return { ...state, isValidateEg: false, refresh: state.refresh + 1, newEgList: [], kanban: { ...initialState.kanban } };
        case EG_SAVE_REQUEST:
            return { ...state, isRequestingSave: true };
        case EG_SAVE_SUCCESS:
            return { ...state, isValidateEg: false, isRequestingSave: false, refresh: state.refresh + 1, newEgList: [] };
        case EG_SAVE_FAILURE:
            return { ...state, isRequestingSave: false };
        case CLEAR_EG_KANBAN:
            return { ...initialState };
        case VALIDATE_EG:
            return { ...state, isValidateEg: action.payload };
        default:
            break;
    }
    return state;
}